import { css } from 'lit';

export const style = css`
	:host {
		display: block;
		height: 100%;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	* {
		box-sizing: border-box;
	}

	.bar {
		display: flex;
		flex-direction: row;
		height: 28px;
		line-height: 28px;
		flex: 0 1 500px;
		border: 1px solid var(--og-bucket-border-color);
		background-color: var(--og-background-color);
		vertical-align: middle;
		text-align: center;
		border-radius: 3px;
		cursor: pointer;
	}

	.bar-icon {
		padding: 2px 5px 0 5px;
		flex: 0;
	}

	.bar-text {
		flex: 1;
		text-align: center;
	}

	.bar:hover {
		border-color: var(--accent-color);
	}

	.bar:hover .bar-icon {
		color: var(--accent-color);
	}
`;
